export class Queue {
  static requestQueue = {};

  static getQueue(name = "system", sendRequest) {
    if (!this.requestQueue[name]) {
      this.requestQueue[name] = new Queue(name, sendRequest);
    }
    return this.requestQueue[name];
  }

  constructor(name, sendRequest) {
    this.name = name;
    this.requestQueue = [];
    this.executeQueue = this.executeQueue.bind(this);
    this.sendRequest = sendRequest;
  }

  queueRequest(url, option, callback) {
    let queueId = new Date().getTime();
    this.requestQueue.push({
      id: queueId,
      url,
      option,
      callback
    });
    //trigger the queue
    this.executeQueue();
  }

  executeQueue(updatedRequestData = null) {
    if (this.requestStatus === "waiting") {
      //break the recurrsion;
      return;
    }
    let requestObj = this.requestQueue.shift();
    if (!requestObj) {
      return;
    }
    //if data is present then update request object with latest data
    if (updatedRequestData) {
      requestObj.option.data = updatedRequestData;
    }
    this.requestStatus = "waiting";
    let res = null;
    let err = null;
    const [promise] = this.sendRequest(requestObj.url, requestObj.option);
    promise()
      .then(
        (data) => {
          res = data;
        },
        (error) => {
          err = error;
        }
      )
      .finally(() => {
        this.requestStatus = "done";
        let shouldWait = (data) => {
          //proceed to next request
          this.executeQueue(data);
        };
        //check if the waiting callback method is accepted in the given callback
        //if so then wait untill callback is called, then proceed with queue execution
        if (requestObj.callback.length === 3) {
          requestObj.callback(err, res, shouldWait);
        } else {
          requestObj.callback(err, res);
          //proceed to next request
          this.executeQueue();
        }
      });
  }

  clear() {
    if (this.name === "system") {
      return;
    }
    Reflect.deleteProperty(Queue.requestQueue, this.name);
  }
}
